// React essentials
import React from 'react';
import { Formik, FormikHelpers } from 'formik';

// Localization
import { useTranslation } from 'react-i18next';

// Form validation and initial values
import { getInitialValues } from 'demoRegistration/initialValues';
import getValidationSchema from 'demoRegistration/validationSchema';

// Custom hooks
import {
  RegisterValues,
  RegistrationError,
  useRegisterMutation,
} from 'shared/hooks/api/demo';

// Handlers
import {
  onRegistrationError,
  onRegistrationSuccess,
} from 'demoRegistration/registrationHandlers';

// Components and styles
import { Card } from 'demoRegistration/styles/RegistrationCard.style';
import IntroCard from 'demoRegistration/components/introCard/IntroCard';
import RegistrationForm from 'demoRegistration/components/RegistrationForm';

type FormValues = Omit<RegisterValues, 'recaptcha_v3_token'>;

const DemoRegistration: React.FC = () => {
  const { t } = useTranslation('pageDemoRegistration');
  const { mutate: register } = useRegisterMutation();

  const handleSubmit = (
    values: FormValues,
    helpers: FormikHelpers<FormValues>
  ) => {
    register(values, {
      onSuccess: () => onRegistrationSuccess(helpers),
      onError: (error) =>
        onRegistrationError(error as RegistrationError, helpers),
    });
  };

  return (
    <>
      <IntroCard t={t} />
      <Card id="registration">
        <Formik
          initialValues={getInitialValues()}
          validationSchema={getValidationSchema(t)}
          onSubmit={handleSubmit}
        >
          {(formikProps) => <RegistrationForm {...formikProps} />}
        </Formik>
      </Card>
    </>
  );
};

export default DemoRegistration;
